export default "__VITE_ASSET__CRcbncbG__"